module.exports = __webpack_public_path__ + "img/laser.e1aa0373.png";